import { render } from "./ImagesDevices.vue?vue&type=template&id=95c25ac6"
import script from "./ImagesDevices.vue?vue&type=script&lang=js"
export * from "./ImagesDevices.vue?vue&type=script&lang=js"

import "./ImagesDevices.vue?vue&type=style&index=0&id=95c25ac6&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__